import { proxy, useSnapshot } from '@workwave-tidal/core/valtio'
import { IAttachmentToAgreementDTO } from '@user/store/attachments'

type SelectStore = {
  selectedAttachments: IAttachmentToAgreementDTO[]
  isSelectionEnable: boolean
}

const store = proxy<SelectStore>({
  selectedAttachments: [],
  isSelectionEnable: false,
})

export function setSelectedAttachments(
  attachments: IAttachmentToAgreementDTO[],
) {
  store.selectedAttachments = attachments
}

export function setIsSelectionEnable(isSelectionEnable: boolean) {
  store.isSelectionEnable = isSelectionEnable
}

export function useSelectedAttachmentStore() {
  return {
    selectedAttachments: useSnapshot(store).selectedAttachments,
    isSelectionEnable: useSnapshot(store).isSelectionEnable,
  }
}
